import { SingleEntityTemplate } from '../../../api/models/assets';
import { TpDataContext } from '../../../data/interfaces';
import Tables from './elements/Table';
import Actions from './elements/Actions';
import NetworkLinks from './elements/NetworkLinks';
import PropertyNumericalTiles from './elements/PropertyNumericalTiles';
import ExternalData from './elements/ExternalData';
import EntityImage from './elements/Image';
import { TpSectionsIndexContext } from '../../../components/sections-index/SectionsIndex';
import { TpSingleEntityViewContext } from './interfaces';
import RelatedTable from './elements/RelatedTable';
import { getUserError } from '../../../components/miscUtils';

interface TpSingleItemViewProps {
  dataContext: TpDataContext;
  entityTypeTemplate: SingleEntityTemplate;
  itemId: string;
  sectionIndexContext: TpSectionsIndexContext;
  singleEntityViewContext: TpSingleEntityViewContext;
}

export function SingleItemViewFactory({
  dataContext,
  entityTypeTemplate,
  itemId,
  sectionIndexContext,
  singleEntityViewContext,
}: TpSingleItemViewProps) {
  const componentMap: { [id: string]: any } = {
    propertyList: Tables,
    actions: Actions,
    network_links: NetworkLinks,
    propertyNumericalTiles: PropertyNumericalTiles,
    relatedTable: RelatedTable,
    externalData: ExternalData,
    image: EntityImage,
  };

  return (
    <>
      {entityTypeTemplate.elements.map((elementTemplate: any, index: number) => {
        const Component = componentMap[elementTemplate.type];

        if (Component) {
          return (
            <Component
              key={`${index}_${JSON.stringify(elementTemplate)}`}
              itemId={itemId}
              dataContext={dataContext}
              entityTypeTemplate={entityTypeTemplate}
              elementTemplate={elementTemplate}
              sectionIndexContext={sectionIndexContext}
              singleEntityViewContext={singleEntityViewContext}
            />
          );
        } else {
          throw getUserError(`Invalid single entity component type: ${elementTemplate.type}`);
        }
        return <div key={index}>Invalid Component type: {elementTemplate.type}</div>;
      })}
    </>
  );
}
